import { __extends } from 'tslib';
import web2clientSounds from '@lst/web2clientapi/sound';
import classNames from 'classnames';
import * as React from 'react';
import styles from './Menu.module.scss.js';

var Menu = (function (_super) {
    __extends(Menu, _super);
    function Menu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isActive: false,
        };
        _this.hide = function (silent) {
            if (silent === void 0) { silent = false; }
            if (_this.state.isActive) {
                _this.setState({ isActive: false });
                if (!silent) {
                    web2clientSounds.playDropdownSound();
                }
            }
        };
        _this.onToggle = function () {
            var isActive = !_this.state.isActive;
            _this.setState({ isActive: isActive });
            if (_this.props.onMenuToggled) {
                _this.props.onMenuToggled(isActive);
            }
            web2clientSounds.playDropdownSound();
        };
        _this.onBlur = function () {
            _this.hide();
            if (_this.props.onMenuBlur) {
                _this.props.onMenuBlur();
            }
        };
        _this.onEscape = function (e) {
            if (e.keyCode === 27 && _this.state.isActive) {
                e.preventDefault();
                _this.hide();
            }
        };
        _this.onScroll = function () {
            _this.hide();
        };
        _this.onItemChange = function (value) {
            _this.hide(true);
            web2clientSounds.playButtonSound();
            _this.props.onItemChange(value);
        };
        return _this;
    }
    Menu.prototype.componentDidMount = function () {
        this.appContainer = document.getElementById('app');
        if (this.appContainer) {
            this.appContainer.addEventListener('scroll', this.onScroll);
        }
        document.addEventListener('keydown', this.onEscape, true);
    };
    Menu.prototype.componentWillUnmount = function () {
        if (this.appContainer) {
            this.appContainer.removeEventListener('scroll', this.onScroll);
        }
        document.removeEventListener('keydown', this.onEscape, true);
    };
    Menu.prototype.render = function () {
        var _a, _b, _c;
        var _this = this;
        var isSmallPadding = this.props.isSmallPadding === true;
        var classNameToggle = classNames(isSmallPadding ? styles.toggleSmall : styles.toggle, (_a = {},
            _a[styles.isActive] = this.state.isActive,
            _a));
        var menuWrapper = classNames(styles.menuWrapper, styles[this.props.dropdownPosition], (_b = {},
            _b[styles.isDropped] = this.state.isActive,
            _b));
        var menuItems = this.props.items.map(function (item, index) {
            var _a;
            var classNameItem = classNames(styles.item, (_a = {},
                _a[styles.isSelected] = _this.props.itemSelected === item.value,
                _a));
            return (React.createElement("div", { className: classNameItem, key: index, onClick: function () {
                    _this.onItemChange(item.value);
                } }, item.content));
        });
        return (React.createElement("div", { className: classNames(styles.container, this.props.className), tabIndex: 1, onBlur: this.onBlur },
            React.createElement("div", { className: classNameToggle, onClick: this.onToggle }, this.props.children),
            React.createElement("div", { className: menuWrapper },
                React.createElement("div", { className: classNames(styles.menu, (_c = {}, _c[styles.rotate] = this.props.dropdownPosition === 'top', _c)) },
                    React.createElement("div", { className: styles.inner }, menuItems)),
                React.createElement("div", { className: styles.triangle }))));
    };
    Menu.defaultProps = {
        dropdownPosition: 'bottom',
    };
    return Menu;
}(React.Component));

export { Menu as default };
//# sourceMappingURL=Menu.js.map
